
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!


export class GenWeatherPhenom {

    abbv: string;
    description: string;
    displayName: string;
    groupId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherPhenom: GenWeatherPhenom);

    constructor( input?: GenWeatherPhenom ) {
        if ( input && typeof input !== 'number' ) {
            this.abbv = input.abbv; // string [string]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            this.groupId = input.groupId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherPhenom[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherPhenom(a));
        } else {
          return [];
        }
    }
}

